export default {
  designationEndpoint: '/bin/crugive/designation.html',
  designationImagesEndpoint: '/bin/crugive/image.html',
  designationNewsletter: '/bin/crugive/newsletter/signup.json',
  designationNewsletterSubscription: '/bin/crugive/newsletter/signup.json',
};
